// extracted by mini-css-extract-plugin
export var dividerLine = "_8i-3";
export var itemImage = "_8i-9";
export var lightDivider = "_8i-4";
export var modalContent = "_8i-5";
export var modalContentCompact = "_8i-6";
export var productCard = "_8i-a";
export var productImage = "_8i-b";
export var productImageCompact = "_8i-7";
export var productImagePlaceholder = "_8i-c";
export var productImagePlaceholderCompact = "_8i-8";
export var progressBarBackground = "_8i-1";
export var progressBarContainer = "_8i-0";
export var progressBarFill = "_8i-2";